<div class="ddr-main-container" [class.dialog-mode]="isInDialog()">
    <mat-card oneCard class="ddr-one-card">
        <mat-card-title style="display: flex; flex-direction: column; margin-bottom: 1rem;">
            <!-- Dialog mode: Show title with close button -->
            <div *ngIf="isInDialog()" class="title-row">
                <span class="mat-title">Due date and reminders</span>
                <button mat-icon-button (click)="onDialogCancel()" class="close-button">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <!-- Regular page mode: Show simple title -->
            <span *ngIf="!isInDialog()" class="mat-title">Due date and reminder</span>
            <mat-slide-toggle [(ngModel)]="DueDateEnabled" [disabled]="!feedbackEnabled || areAllAccountsFeedbackOverdue()" (change)="updateEnabled($event.checked)" style="font-size: 16px;">
                Enabled
            </mat-slide-toggle>
        </mat-card-title>
        <mat-card-content *ngIf="!DueDateEnabled">
            <div style="display: flex; align-items: center; justify-content: space-between;">
                <span>The notification will not have a due date and will never be overdue.</span>
                <button *ngIf="isInDialog()" mat-flat-button color="primary" [disabled]="!feedbackEnabled" (click)="saveDueDateDisabled()">Save</button>
            </div>
        </mat-card-content>
        <mat-card-content *ngIf="DueDateEnabled">
            <div class="ddr-duedate-section">
                <h4>Due date</h4>
                <p>Set the date, by which the customer should provide feedback the latest:</p>
                <div style="display: flex; align-items: center; gap: 1rem;">
                    <mat-form-field appearance="outline" class="ddr-template-txt-box" oneFormField>
                        <mat-label>Feedback due date</mat-label>
                        <input
                        matInput
                        [formControl]="feedbackDueDate"
                        [matDatepicker]="feedbackDatepicker"
                        [matDatepickerFilter]="feedbackDueDateFilter"
                        [disabled]="areAllAccountsFeedbackOverdue()"
                        (focus)="feedbackDatepicker.open()"
                        (dateChange)="onFeedbackDueDateChange($event)"
                        data-test-id="basic-datepicker-component.input"
                        />
                      <mat-datepicker-toggle matSuffix [for]="feedbackDatepicker" [disabled]="areAllAccountsFeedbackOverdue()"></mat-datepicker-toggle>
                      <mat-datepicker #feedbackDatepicker></mat-datepicker>
                    </mat-form-field>
                    <button 
                            mat-flat-button 
                            color="primary" 
                            *ngIf="isInDialog() && canSaveFeedbackDueDate() && !areAllAccountsFeedbackOverdue()"
                            (click)="saveFeedbackDueDate()"
                            style="margin-top: 0.25rem;">
                        Save
                    </button>
                </div>
            </div>
            <div class="ddr-reminder-section">
                <div class="reminder-header">
                    <div class="reminder-info">
                        <h4>Reminder(s)</h4>
                        <p>Click on "Add reminder" to add the reminder(s) you want to send to the customer.</p>
                    </div>
                    <div class="ddr-add-reminder-button" *ngIf="!isInDialog()">
                        <button (click)="openReminderTemplateDialog()" [disabled]="!feedbackDueDate.value || feedbackDueDate.invalid || areAllAccountsFeedbackOverdue()" class="btn-add-reminder" mat-stroked-button one-secondary-button>
                            <span>Add Reminder</span>
                        </button>
                    </div>
                </div>
                <div class="ddr-reminder-table-container">
                    <dl-reminder-table [displayedColumns]="remindersColumn" [tableData]="remindersData" [isDialogMode]="isInDialog()" [notificationData]="notificationData" [onEditReminder]="editReminderCallback" [onDeleteReminder]="deleteReminderCallback" *ngIf="remindersData && remindersData.length > 0"></dl-reminder-table>
                </div>
                <div *ngIf="isInDialog()" class="ddr-action-btn-row" style="margin-top: 1.5rem; text-align: right; display: flex; justify-content: flex-end; gap: 1rem;">
                    <button (click)="openReminderTemplateDialog()" [disabled]="!feedbackDueDate.value || feedbackDueDate.invalid || areAllAccountsFeedbackOverdue()" class="btn-add-reminder" mat-stroked-button one-secondary-button>
                        <span>Add Reminder</span>
                    </button>
                    <button mat-flat-button color="primary" (click)="onDialogCancel()">Close</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
